__turbopack_context__.v({
  "bg-standard": "nzRVtq_bg-standard",
  "bg-subtle": "nzRVtq_bg-subtle",
  "image": "nzRVtq_image",
  "placeholder": "nzRVtq_placeholder",
  "slide": "nzRVtq_slide",
  "timestamp": "nzRVtq_timestamp",
});
